export const angustias = {
	nombre: "Angustias",
	dia: "Miércoles Santo",
	nombrecompleto:
		"Venerable Cofradía de Penitencia de Nuestra Señora de las Angustias y San Nicolás de Bari Vulgo El Caminito",
	sede: "Capilla del Caminito",
	pasos: 1,
	distancia: [1470, 1380],
	penitentes: 240,
	cargadores: 46,
	web: "http://www.diariodecadiz.es/semana_santa/Caminito_0_1229277829.html",

	ida: [
		{ lng: -6.2946121, lat: 36.5363608 },
		{ lng: -6.2945156, lat: 36.536544 },
		{ lng: -6.2941937, lat: 36.5364588 },
		{ lng: -6.2938853, lat: 36.5361905 },
		{ lng: -6.2934534, lat: 36.5362703 },
		{ lng: -6.2935513, lat: 36.5368349 },
		{ lng: -6.2945048, lat: 36.536635 },
		{ lng: -6.2955019, lat: 36.5347404 },
		{ lng: -6.295802, lat: 36.5344116 },
		{ lng: -6.2922062, lat: 36.5302961 },
		{ lng: -6.2927909, lat: 36.5297648 },
		{ lng: -6.2934098, lat: 36.5297045 },
		{ lng: -6.2944837, lat: 36.5296382 },
		{ lng: -6.2946142, lat: 36.5295574 },
		{ lng: -6.2950309, lat: 36.5296013 },
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2956837, lat: 36.529101 },
		{ lng: -6.2954262, lat: 36.5297562 },
		{ lng: -6.2956703, lat: 36.5299609 },
		{ lng: -6.2952787, lat: 36.5303597 },
		{ lng: -6.2950131, lat: 36.5308338 },
		{ lng: -6.2949246, lat: 36.5308446 },
		{ lng: -6.2949327, lat: 36.5314567 },
		{ lng: -6.2964776, lat: 36.5317778 },
		{ lng: -6.2963998, lat: 36.5318597 },
		{ lng: -6.2970865, lat: 36.5329998 },
		{ lng: -6.2976766, lat: 36.5335699 },
		{ lng: -6.2984745, lat: 36.5343479 },
		{ lng: -6.2977047, lat: 36.5350634 },
		{ lng: -6.2966841, lat: 36.5346679 },
		{ lng: -6.2963288, lat: 36.5343069 },
		{ lng: -6.2960793, lat: 36.5344449 },
		{ lng: -6.2957695, lat: 36.5344826 },
		{ lng: -6.2955174, lat: 36.534753 },
		{ lng: -6.2946537, lat: 36.5363942 },
		{ lng: -6.2946014, lat: 36.5363737 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-28T19:40",
			latlng: [36.53635, -6.29455]
		},
		{
			name: "Nueva",
			hora: "2018-03-28T20:40",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-28T21:40",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-28T22:30",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-28T23:05",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-28T23:20",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Isabel la Católica",
			"Plaza Argüelles",
			"Conde O’Reilly",
			"Costa Rica",
			"Honduras",
			"Isabel La Católica",
			"Plaza Stmo. Cristo de la Vera Cruz",
			"Plaza San Francisco",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañes", "Palillero"],
		["Novena"],
		[
			"Ancha",
			"San José (Drcha.)",
			"Plaza de Mina",
			"Tinte",
			"Plaza de San Francisco",
			"Plaza Stmo. Cristo de la Vera Cruz",
			"Isabel la Católica"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/angustias.js